import React from 'react'
import { FaLink, FaUnlink } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type KindSpringControlProps = {
  pullsTogether: boolean
  onClick: () => void
}

const KindSpringControl = ({ pullsTogether, onClick }: KindSpringControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick()
  }

  const label = pullsTogether ? 'Stop pulling ends of this kind together' : 'Pull ends of this kind together'

  return (
    <div className={cn('control', 'kind-spring')} data-graph-type="control" title={label}>
      <a className="icon" onClick={handleClick}>
        {pullsTogether ? <FaLink aria-hidden /> : <FaUnlink aria-hidden />}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default KindSpringControl
